import { VENUE_TYPES } from './constants';
import { FormSection } from '../../components/ui/FormSection';
import type { VenueType } from './constants';

interface BasicInformationSectionProps {
  name: string;
  onNameChange: (value: string) => void;
  venueType: VenueType;
  onVenueTypeChange: (value: VenueType) => void;
  description: string;
  onDescriptionChange: (value: string) => void;
}

export const BasicInformationSection = ({
  name,
  onNameChange,
  venueType,
  onVenueTypeChange,
  description,
  onDescriptionChange,
}: BasicInformationSectionProps) => (
  <FormSection title="Basic Information">
    <div>
      <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
        Venue Name *
      </label>
      <input
        type="text"
        id="name"
        value={name}
        onChange={(e) => onNameChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
        placeholder="Enter venue name"
        required
      />
    </div>

    <div>
      <label htmlFor="venueType" className="block text-sm font-medium text-gray-700 mb-1">
        Venue Type *
      </label>
      <select
        id="venueType"
        value={venueType}
        onChange={(e) => onVenueTypeChange(e.target.value as VenueType)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
      >
        {VENUE_TYPES.map((type) => (
          <option key={type} value={type}>
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </option>
        ))}
      </select>
    </div>

    <div>
      <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
        Description
      </label>
      <textarea
        id="description"
        value={description}
        onChange={(e) => onDescriptionChange(e.target.value)}
        rows={4}
        className="w-full px-3 py-2 border border-gray-300 rounded-md"
        placeholder="Enter venue description"
      />
    </div>
  </FormSection>
);
